/* eslint-disable max-len */
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SynchronizationComponent} from './synchronization.component';
import {EffectsModule} from '@ngrx/effects';
import {SynchronizationEffects} from './synchronization.effects';
import {
  SynchronizationConfigurationDropdownComponent
} from './synchronization-configuration-dropdown/synchronization-configuration-dropdown.component';
import {
  SynchronizationTaskHistoryComponent
} from './synchronization-task-history/synchronization-task-history.component';
import {SharedModule} from '../shared.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {
  SynchronizationConfigurationCreateComponent
} from './synchronization-configuration-create/synchronization-configuration-create.component';
import {StoreModule} from '@ngrx/store';
import {reducer, synchronizationFeatureKey} from './synchronization.reducer';


@NgModule({
  declarations: [
    SynchronizationComponent,
    SynchronizationConfigurationDropdownComponent,
    SynchronizationTaskHistoryComponent,
    SynchronizationConfigurationCreateComponent
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(synchronizationFeatureKey, reducer),
    EffectsModule.forFeature([SynchronizationEffects]),
    SharedModule,
    MatProgressSpinnerModule
  ]
})
export class SynchronizationModule {
}
